
<template>
  <div :class="$style.modal"
       :style="modalStyle">
    <slot name="header">
      <div :class="$style.header">
        <slot name="header-content">
          <h2>{{ title }}</h2>
          <button
              type="button"
              :class="$style.headerButton"
              @click="closeModal"
          >
            Sluit venster<i class="icon-cross"></i>
          </button>
        </slot>
      </div>
    </slot>

    <slot name="body">
      <div :class="$style.body">
        <slot>
          Content...
        </slot>
      </div>
    </slot>

    <slot name="footer">
      <div :class="$style.footer">
        <slot name="footer-content">
          <button type="button" @click="closeModal">
            Sluit venster
          </button>
        </slot>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "side-modal",
  components: {},
  props: {
    title: {type: String},
    width: {type: String, default: "800px"}
  },
  computed: {
    modalStyle() {
      return [{
        width: this.width
      }]
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>

<style module lang="scss">
@keyframes bvm-slide-modal-slide-transition {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
}

.modal {
  overflow-x: hidden;
  overflow-y: auto;
  opacity: 1;
  top: 0;
  visibility: visible;
  right: 0;
  height: 100%;
  position: fixed;
  max-width: 940px;
  left: auto;
  padding-right: 0 !important;
  margin-top: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  animation-name: bvm-slide-modal-slide-transition;
  animation-timing-function: ease-out;
  animation-duration: 0.4s;
}

.header {
  height: 52px;
  display: flex;
  padding: 1rem;
  border-bottom: 1px solid #ececec;
  align-items: flex-start;
  justify-content: flex-end;
}

.headerButton {
  height: 52px;
  font-size: 16px;
  line-height: 26px;
  color: #1a1a1a;
  opacity: 1;
  cursor: pointer;
  margin: -1rem 0 -1rem auto;
  border: 0;
  font-weight: 700;
  text-shadow: 0 1px 0 #fff;
  background-color: transparent;
  font-family: Walsheim-Pro-Medium;
}

.body {
  padding: 30px;
  height: 100%;
}

.footer {
  height: 52px;
  display: flex;
  padding: 1rem;
  border-top: 1px solid #ececec;
  align-items: flex-start;
  justify-content: flex-end;
}
</style>
